if (!window.BacteriaCartAddons) {
    window.BacteriaCartAddons = (function () {
      var busy = false;

      function cartUrl() {
        return window.theme && window.theme.routes && window.theme.routes.cart_url
          ? window.theme.routes.cart_url + '.js'
          : '/cart.js';
      }

      function addUrl() {
        return window.theme && window.theme.routes && window.theme.routes.cart_add_url
          ? window.theme.routes.cart_add_url + '.js'
          : '/cart/add.js';
      }

      function setButtonState(button, inCart) {
        if (!button || button.dataset.adding === 'true') return;
        button.disabled = !!inCart;
        button.textContent = inCart ? 'In cart' : 'Add';
      }

      function syncButtons() {
        var buttons = document.querySelectorAll('[data-cart-addon-button]');
        if (!buttons.length) return;

        fetch(cartUrl(), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : Promise.reject(response); })
          .then(function (cart) {
            var variantIds = (cart.items || []).map(function (item) { return String(item.variant_id); });
            buttons.forEach(function (button) {
              setButtonState(button, variantIds.indexOf(String(button.dataset.variantId)) !== -1);
            });
          })
          .catch(function () {});
      }

      function addItem(button) {
        if (busy || !button || button.disabled) return;
        busy = true;
        button.dataset.adding = 'true';
        button.disabled = true;
        button.textContent = 'Adding…';

        fetch(addUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (data) { throw data; });
            return response.json();
          })
          .then(function () {
            button.dataset.adding = 'false';
            button.textContent = 'In cart';
            button.disabled = true;

            if (button.dataset.cartAddonContext === 'page' && window.location.pathname.indexOf('/cart') !== -1) {
              window.location.reload();
              return;
            }

            document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
            setTimeout(syncButtons, 250);
          })
          .catch(function () {
            button.dataset.adding = 'false';
            button.disabled = false;
            button.textContent = 'Try again';
          })
          .finally(function () {
            busy = false;
          });
      }

      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-cart-addon-button]');
        if (button) {
          event.preventDefault();
          addItem(button);
        }
      });

      document.body.addEventListener('baseline:modalcart:itemcountupdate', function () {
        setTimeout(syncButtons, 100);
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncButtons);
      } else {
        syncButtons();
      }

      return { sync: syncButtons };
    })();
  }
